import Nav from './components/nav-bar';
import Home from './components/home';
import About from './components/about';
import Services from './components/services';
import Feedbacks from './components/feedbacks';
import Contact from './components/contact';

export default function App() {
  return (
    <>
      <Nav />
      <Home />
      <About />
      <Services />
      <Feedbacks />
      <Contact />
    </>
  )
}